/** The request-sent page piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { RequestSentEvents } from './contract';
import { RequestSentView } from './RequestSentView';
import { useRequestSent } from './useRequestSent';

export { RequestSentView, useRequestSent };

export function RequestSent(props: PieceInput<RequestSentEvents>) {
  return <RequestSentView {...useRequestSent(props)} />;
}
